import useTranslation from "../../hooks/useTranslation";
import { Event } from "../../models/activity";
import { EventType } from "../../types/actionPlan";
import { DatePicker } from "../ui/Input/DatePicker";
import { Tooltip } from "../ui/Tooltip/Tooltip";
import { Typography } from "../ui/Typography/Typography";
import { IconTypes } from "../ui/icons";
import { Icon } from "../ui/icons/Icon";
import "./ActionPlanActivity.scss";

interface ActionPlanEventProps {
  event: Event;
  description?: string;
  info?: string;
  onDateChange: (newDate: Date) => void;
}

export const ActionPlanEvent = ({
  event,
  description,
  info,
  onDateChange,
}: ActionPlanEventProps) => {
  const { t } = useTranslation("actionPlanPage");
  const handleDateChange = (newDate: Date | null) => {
    if (newDate) {
      onDateChange(newDate);
    }
  };

  const getEventLabel = () => {
    if (event.eventType === EventType.ScheduleSurveyLaunch) {
      return t("timeline.planSurvey.dateLabel");
    }
    return event.label;
  };

  return (
    <div className="ActionPlanEvent">
      <div className="ActionPlanEvent__info">
        <Typography desktop="body2" weight="bold">
          {getEventLabel()}
        </Typography>
        {description && (
          <Typography desktop="body2" color="secondary">
            {description}
          </Typography>
        )}
      </div>
      <div className="ActionPlanEvent__date">
        <DatePicker
          defaultValue={new Date(event.date)}
          onChange={handleDateChange}
          dataTestId={`event-date-${event.id}`}
        />
        {info && (
          <Tooltip
            title=""
            cardContent={
              <div>
                <Typography desktop="body1" color="secondary">
                  {info}
                </Typography>
              </div>
            }
            arrow
            placement="right"
          >
            <span className="ActionPlanEvent__date__icon">
              <Icon type={IconTypes.Help} size={20} />
            </span>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
